import React from 'react';
import { Stack } from 'expo-router';

import { useModalStackOptions } from '../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function ModalsLayout() {
  const options = useModalStackOptions();

  return (
    <Stack screenOptions={options.Stack}>
      <Stack.Screen name="add-gift-card/index" options={options.AddGiftCard} />
      <Stack.Screen
        name="add-gift-card/[giftCardId]/index"
        options={options.AddGiftCard}
      />
      <Stack.Screen name="bag/index" options={options.Bag} />
      <Stack.Screen
        name="ca-data-requests/index"
        options={options.WithHeader}
      />
      <Stack.Screen name="chat/index" options={options.Chat} />
      <Stack.Screen name="credit/add/index" options={options.WithHeader} />
      <Stack.Screen name="credit/index" options={options.WithHeader} />
      <Stack.Screen
        name="delivery-order-in-flight/index"
        options={options.DeliveryOrderInFlight}
      />
      <Stack.Screen
        name="dietary-restrictions/index"
        options={options.WithHeader}
      />
      <Stack.Screen
        name="feedback/[orderId]/index"
        options={options.Feedback}
      />
      <Stack.Screen
        name="order-product/[productSlug]/confirm-location/index"
        options={options.OrderProduct}
      />
      <Stack.Screen
        name="order-product/[productSlug]/index"
        options={options.OrderProduct}
      />
      <Stack.Screen
        name="order-product/[productSlug]/search-location/index"
        options={options.OrderProduct}
      />
      <Stack.Screen
        name="order-status/[orderId]/index"
        options={options.WithHeader}
      />
      <Stack.Screen name="personal-data/index" options={options.PersonalData} />
      <Stack.Screen
        name="personal-data-details/index"
        options={options.RequestData}
      />
      <Stack.Screen
        name="redeem-gift-card/index"
        options={options.RedeemGiftCard}
      />
      <Stack.Screen
        name="redeem-gift-card/[giftCardId]/index"
        options={options.RedeemGiftCard}
      />
      <Stack.Screen name="reorder/index" options={options.Reorder} />
      <Stack.Screen
        name="share/[lineItemSlug]/index"
        options={options.WithHeader}
      />
      <Stack.Screen name="upsell/index" options={options.Upsell} />
    </Stack>
  );
}
